/**
 * 文字コード選択コンポーネント
 *
 * Shift_JIS / UTF-8 の選択と説明ポップオーバー
 */

import {
  Select,
  Group,
  Text,
  Popover,
  ActionIcon,
  Stack,
  Box,
  Divider,
} from "@mantine/core";
import { Info } from "lucide-react";
import { CsvEncoding } from "../../services/csvSettingsService";

interface EncodingSelectProps {
  value: CsvEncoding;
  onChange: (value: CsvEncoding) => void;
}

/**
 * 文字コード選択
 */
export function EncodingSelect({ value, onChange }: EncodingSelectProps) {
  return (
    <Select
      label={
        <Group gap={4}>
          <Text component="span" size="sm" fw={500}>
            文字コード
          </Text>
          <Popover width={320} position="bottom-end" shadow="md" withArrow>
            <Popover.Target>
              <ActionIcon variant="transparent" size="xs" color="gray" aria-label="詳細">
                <Info size={12} />
              </ActionIcon>
            </Popover.Target>
            <Popover.Dropdown>
              <Stack gap="xs">
                <Text size="xs" fw={700}>
                  文字コードの選び方
                </Text>
                <Box>
                  <Text size="xs" fw={700} c="orange.8">
                    Shift_JIS
                  </Text>
                  <Text size="xs">
                    Excelで直接開く場合や、古い基幹システムに取り込む場合に推奨されます。
                    <br />
                    ※丸数字（①など）や一部の環境依存文字が文字化けする可能性があります。
                  </Text>
                </Box>
                <Divider my={4} />
                <Box>
                  <Text size="xs" fw={700} c="blue.8">
                    UTF-8 (BOM付)
                  </Text>
                  <Text size="xs">
                    最新のシステムやWebサービス間での連携に最適です。
                    <br />
                    あらゆる文字を扱えますが、対応していない古いシステムでは読み込めない場合があります。
                    Excelで開く際は「BOM付き」であれば文字化けしません。
                  </Text>
                </Box>
              </Stack>
            </Popover.Dropdown>
          </Popover>
        </Group>
      }
      data={["utf-8", "shift_jis"]}
      value={value}
      onChange={(val) => onChange(val as CsvEncoding)}
    />
  );
}
